import { typeOf } from '@ember/utils';
import InfinityModel from 'ember-infinity/lib/infinity-model';
import ArrayProxy from "@ember/array/proxy";
import { A } from '@ember/array';
import { get } from "@ember/object";

import type Ember from "ember";
import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';

export function decorateApiQuery(query: IJsonApiQuery = {}, perPage = 50) {
  const decoratedQuery = {
    ...query,
    perPage,
    startingPage: 0,
    perPageParam: 'page[limit]',
    pageParam: 'page[offset]',
    countParam: 'meta.totalCount',
    totalPagesParam: 'meta.totalPages'
  };
  delete decoratedQuery.page;

  return decoratedQuery;
}

export default class JsonApiInfinityModel extends InfinityModel {
  buildParams(increment: number) {
    const pageParams = super.buildParams(increment);

    if (typeOf(this.pageParam) === 'string' && this.pageParam.includes('offset')) {
      pageParams[this.pageParam] = (this.currentPage + increment) * this.perPage;
    }

    return pageParams;
  }

  /**
   * abstract after-model hook, can be overridden in subclasses
   * Used to keep shape for optimization
   */
  afterInfinityModel(
    newObjects: Ember.Array<any>,
    infinityModels: InfinityModel
  ): Promise<Ember.Array<any>> {
    return Promise.resolve(
      ArrayProxy.create({
        content: A(newObjects.filter((o) => !infinityModels.includes(o))),
        meta: get(newObjects, 'meta')
      })
    );
  }
}
